import React from 'react';
import { mergeClasses, Textarea, Button } from '@fluentui/react-components';
import { Send20Regular } from '@fluentui/react-icons';
import PropTypes from 'prop-types';
import { getHomePageTopBannerContainerStyle } from '../home-page-styles';

const TopHomePageBannerComponent = ({ i18n, onSearch }) => {
  const [searchQuery, setSearchQuery] = React.useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);

    if (event.key === 'Enter') {
      event.preventDefault();
      if (event.target.value.trim()) {
        onSearch(event.target.value);
      }
    }
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      onSearch(searchQuery);
    }
  };

  const classes = getHomePageTopBannerContainerStyle();

  return (
    <div className={classes.topBanner}>
      <div className={classes.texts}>
        <div className={classes.pageName}>
          <div role="heading" aria-level="1">{i18n.getString(_TL_('What assets are you searching for today?'))}</div>
        </div>
        <div className={classes.searchContainer}>
          <div className={classes.searchBoxWrapper}>
            <Textarea
              className={mergeClasses('search-area', classes.searchBox)}
              appearance="outline"
              placeholder={i18n.getString(_TL_("Enter an image name, ID, or a description of the image's content."))}
              size="large"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleSearchChange}
            />
            <Button
              icon={<Send20Regular />}
              appearance="transparent"
              onClick={handleSearch}
              className={classes.sendIcon}
              aria-label={i18n.getString(_TL_('Search'))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


TopHomePageBannerComponent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      Name: PropTypes.string,
    }),
  }),
};

TopHomePageBannerComponent.defaultProps = {
  serverContext: {},
};

export default TopHomePageBannerComponent;
